import Axios from "axios";
var PlanOrderForUpperSupService = (function () {
    function PlanOrderForUpperSupService() {
    }
    PlanOrderForUpperSupService.prototype.getList = function (params) {
        return Axios.get("supplierclientapi/planorder/list", { params: params });
    };
    PlanOrderForUpperSupService.prototype.getListOrders = function (params) {
        return Axios.get("supplierclientapi/upper_purchase_order/list", { params: params });
    };
    PlanOrderForUpperSupService.prototype.getPlanOrderGoodslist = function (params) {
        return Axios.post("supplierclientapi/planorder/goods_list", params);
    };
    PlanOrderForUpperSupService.prototype.addPlanOrder = function (params) {
        return Axios.post("supplierclientapi/planorder/create", params);
    };
    PlanOrderForUpperSupService.prototype.getDetail = function (params) {
        return Axios.get("supplierclientapi/planorder/detail", { params: params });
    };
    PlanOrderForUpperSupService.prototype.updatePlanOrder = function (params) {
        return Axios.post("supplierclientapi/planorder/update", params);
    };
    PlanOrderForUpperSupService.prototype.audit = function (params) {
        return Axios.get("supplierclientapi/planorder/audit", { params: params });
    };
    PlanOrderForUpperSupService.prototype.discard = function (params) {
        return Axios.get("supplierclientapi/planorder/cancel", { params: params });
    };
    PlanOrderForUpperSupService.prototype.getSupplierupperOptions = function (params) {
        return Axios.get("supplierclientapi/planorder/supplier_list", { params: params });
    };
    PlanOrderForUpperSupService.prototype.getAccountOptions = function (params) {
        return Axios.get("supplierclientapi/account/get_options", { params: params });
    };
    PlanOrderForUpperSupService.prototype.getSupplierorganOptions = function (params) {
        return Axios.get("supplierclientapi/supplierorgan/get_options", { params: params });
    };
    PlanOrderForUpperSupService.prototype.getSupplierdepotOptions = function (params) {
        return Axios.get("supplierclientapi/supplierdepot/get_options", { params: params });
    };
    PlanOrderForUpperSupService.createInstance = function () {
        PlanOrderForUpperSupService.getInstance();
    };
    PlanOrderForUpperSupService.getInstance = function () {
        return this._instance || (this._instance = new this());
    };
    return PlanOrderForUpperSupService;
}());
export default PlanOrderForUpperSupService;
